<template>
  <el-container>
    <el-aside class="leftMenuContainer">
      <!--左侧工作区-->
      <el-col :span="24" v-if="showMenuFlag">
        <leftMenu :activeIndex='"fid_" + fid' :random="random"></leftMenu>
      </el-col>
    </el-aside>
    <el-main class="work_container">

      <el-row style="background-color: white;height: 100vh;">
        <!--右侧文章区-->
        <el-col :span="22" :offset="1">
          <el-row style="clear:both;height:40px"></el-row>
          <el-row class="toolbar">

            <el-col :span="8" class="t_l">
              <span class="pageTitle">我的文章库 </span><br>

            </el-col>

            <el-col :span="16" class="t_r">
              <el-button @click="toAddFolder"> <i
                  class="iconfont_yx">&#xe619;</i>&nbsp;新建文件夹</el-button>&nbsp;&nbsp;&nbsp;
              <el-input placeholder="请输入内容" v-model="keyword" suffix-icon="el-icon-search" class="search_input">
              </el-input>

              <!-- <el-checkbox v-model="checkAllVal" @change="checkAll" v-if="typeValue == 'card'">全选</el-checkbox> -->

            </el-col>
          </el-row>
          <el-row style="clear:both;height:10px"></el-row>
          <el-row>

            <el-col :span="12" class="t_l">

              <el-breadcrumb separator-class="el-icon-arrow-right" style="display:inline-block;padding-top: 15px;">
                <el-breadcrumb-item> <el-link :underline="false"
                    @click="editArticle(-1, 'FOLDER')">我的文章</el-link></el-breadcrumb-item>
                <el-breadcrumb-item v-for="item in folderList" :key="item.id"><el-link :underline="false"
                    @click="editArticle(item.id, 'FOLDER')">{{ item.label }}</el-link></el-breadcrumb-item>
              </el-breadcrumb>

            </el-col>
            <el-col :span="12" class="t_r">
              <template v-if="hasAnyChoose">
                <el-link :underline="false" size="mini" :disabled="!hasAnyChoose"
                  @click="batchRecycle">批量删除</el-link>&nbsp;
                <el-link :underline="false" size="mini" :disabled="!hasAnyChoose"
                  @click="batchExport">批量导出</el-link>&nbsp;
              </template>
              <div class="articleTypeRadio">
                <el-radio v-model="typeValue" label="card" @change="changeTypeValue">
                  <div class="card"></div>
                </el-radio>
                <el-radio v-model="typeValue" label="list" @change="changeTypeValue">
                  <div class="list"></div>
                </el-radio>
              </div>

            </el-col>
          </el-row>
          <br>
          <el-row>
            <div :key="tableIndex" class=" infinite-list scrollContainer" v-infinite-scroll="searchArticles"
              :infinite-scroll-delay=500 :infinite-scroll-distance=100 :infinite-scroll-immediate=true
              :infinite-scroll-disabled='infiniteFinish' style="overflow:auto;height: calc(100vh - 166px);">
              <ul v-if="'card' == typeValue" style="padding: 0px;margin: 0px;">
                <div v-for="(item, index) in articles" style="float:left;position:relative" :key="index">

                  <xyCard :key="item.id" :fileType="item.fileType" :index="index" :keywords="item.keywords"
                    @recycleArticle="toRecycleArticle" @editArticle="editArticle" @moveArticle="moveArticle"
                    @exportArticle="exportArticle" :title="item.title" :content="item.description" :time="item.updateTime"
                    :article_id='item.id' @toRenameFolder="toRenameFolder" @toRecycleArticle="toRecycleArticle">
                  </xyCard>
                  <el-checkbox v-model="checkList[index]" class="article_checkbox">&nbsp;</el-checkbox>
                </div>
              </ul>

              <el-table v-else :data="articles" highlight-current-row @selection-change="handleSelectionChange"
                style="width: 100%;">
                <el-table-column width="50" type="selection" label="操作">
                </el-table-column>
                <el-table-column label="标题">
                  <template slot-scope="scope">
                    <div :class="'tag_' + scope.row.fileType"></div>
                    <el-link :underline="false" @click="editArticle(scope.row.id, scope.row.fileType)">{{
                      scope.row.title ||
                      '【未设置标题】' }}</el-link>

                  </template>
                </el-table-column>

                <el-table-column property="updateTime" label="更新时间" width="250">
                </el-table-column>
                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <template v-if="scope.row.fileType === 'NEWS'">
                      <el-link type="primary" @click="exportArticle(scope.row.id)">导出</el-link>
                      <el-link type="primary">|</el-link>
                      <el-popover placement="top-start" :width="60" trigger="click" :ref="'opt_popover' + scope.row.id">
                        <template #reference>
                          <el-link type="primary">更多</el-link>
                        </template>
                        <el-link style="color:#333" @click="moveArticle(scope.row.id, scope.$index)">移动</el-link>
                        <el-link type="danger" @click=" toRecycleArticle(scope.row.id, scope.$index)">删除</el-link>
                      </el-popover>
                    </template>
                    <template v-if="scope.row.fileType === 'FOLDER'">
                      <el-popover placement="top-start" :width="60" trigger="click" :ref="'opt_popover' + scope.row.id">
                        <template #reference>
                          <el-link type="primary">更多</el-link>
                        </template>
                        <el-link @click="toRenameFolder(scope.row.id, scope.row.title)" style="color:#333">重命名</el-link>
                        <el-link @click="moveArticle(scope.row.id, scope.$index)" style="color:#333">移动</el-link>
                        <el-link @click="toRecycleArticle(scope.row.id, scope.$index)" type="danger">删除</el-link>
                      </el-popover>
                    </template>

                  </template>
                </el-table-column>
                <template slot=" empty">
                  <div class="noFile"></div>
                </template>
              </el-table>
              <div style="clear:both"></div>
              <template v-if="infiniteFinish">
                <div class="noData" v-if="articles.length > 0">
                  <i class="iconfont">&#xe629;</i>&nbsp;&nbsp;&nbsp;&nbsp;
                  数据加载完毕!
                </div>
              </template>
              <template v-else>
                <div class="noData">
                  <span class="icon_run">
                    <i class="iconfont">&#xe67b;</i>
                  </span>&nbsp;&nbsp;&nbsp;&nbsp;数据加载中...
                </div>
              </template>
            </div>
            <div style="clear:both"></div>
          </el-row>

        </el-col>
      </el-row>
    </el-main>

    <el-dialog :visible.sync="deleteDialogVisible" custom-class="dangerDialog" title="删除" width="450px"
      :close-on-click-modal="false">
      确认删除文件？7天内可从回收站恢复已删除文件。
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="recycleArticle">
            确认
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="选择文集" :visible.sync="moveDialogVisible" width="30%" custom-class="commonDialog">
      <div class="folderContainer">
        <el-tree :data="[folders]" :default-expanded-keys="[-1]" @node-click='handleNodeClick' node-key="id">
        </el-tree>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="moveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subMoveArticle">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addFolderDialogVisible" custom-class="commonDialog" :close-on-click-modal="false"
      title="新建文件夹" :close-on-press-escape="false">
      <div class="lable">请输入文件夹名称</div>
      <el-input v-model="curFolder.name" placeholder="" class="input"></el-input>
      <el-row style="clear:both;min-height:80px;text-align:left">
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFolderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFolder">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="renameFolderDialogVisible" custom-class="commonDialog" :close-on-click-modal="false"
      title="重命名" :close-on-press-escape="false">
      <div class="lable">请输入新名称</div>

      <el-input v-model="curFolder.name" placeholder="" class="input"></el-input>
      <el-row style="clear:both;min-height:80px;text-align:left">
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renameFolderDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="renameForder">确 定</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>
import xyCard from '../components/xy_card'
import leftMenu from '../components/left_menu'
import * as appJs from '../assets/js/app'
export default {

  data: function () {
    return {
      random: 1,
      keyword: '',
      articles: [],
      deleteDialogVisible: false,
      curId: -1,
      tableIndex: 0,
      referList: [],
      referIndex: 0,
      articleId: '',
      loading: false,
      xyCardIndex: 0,
      checkList: [],
      addFolderDialogVisible: false,
      renameFolderDialogVisible: false,

      typeValue: '',
      infiniteFinish: false,
      checkAllVal: false,
      folderList: [],
      fid: -1,
      showMenuFlag: true,
      folders: { 'label': '我的文章库', 'id': -1 },
      moveDialogVisible: false,
      moveArticleId: 0,
      chooseForlder: {},
      hasAnyChoose: false,
      curFolder: {}
    }
  },
  methods: {

    getMyFolder () {
      let _this = this
      this.axios.get('/webApi/v3/article/myListFolder').then((response) => {
        _this.folders.children = response.data
      })
    },

    toAddFolder () {
      this.curFolder = {}
      this.addFolderDialogVisible = true
    },
    // 添加文集
    addFolder () {
      let _this = this
      if (!_this.curFolder.name || _this.curFolder.name.trim() === '') {
        this.$message.error('文件夹名不能为空');
        return
      }
      this.axios.post('/webApi/v3/article/addFolder', { 'folderName': _this.curFolder.name, 'parentId': this.fid }).then((response) => {
        _this.toSearchArticles()
        _this.addFolderDialogVisible = false
        this.$message({
          type: 'success',
          message: '文件夹添加成功'
        })
        _this.random++;
        _this.getMyFolder()
      })
    },
    changeTypeValue () {
      localStorage.setItem('myarticle_type_value', this.typeValue)
    },
    handleNodeClick (data) {
      this.chooseForlder = data
    },
    subMoveArticle () {
      let _this = this
      if (_this.chooseForlder.id === this.fid) {
        _this.moveDialogVisible = false
        return
      }
      this.axios.post('/webApi/v3/article/move', { 'id': this.moveArticleId, 'folderId': this.chooseForlder.id }).then((resp) => {
        _this.moveDialogVisible = false
        _this.articles.splice(this.curIndex, 1)
      })
    },
    // 移动文章
    moveArticle (id, curIndex) {
      this.curIndex = curIndex
      this.moveArticleId = id
      this.moveDialogVisible = true
    },

    editArticle (articleId, fileType) {
      appJs.checkVip().then(() => {
        if (fileType === 'NEWS') {
          this.$router.push({ path: '/newsEdit', query: { 'articleId': articleId, 'fid': this.fid } })
        } else {
          this.$router.push({ path: '/articles', query: { 'fid': articleId } })
        }
      })
    },
    async searchArticles () {
      let _this = this
      this.axios.get('/webApi/v3/article/myListData?folderId=' + _this.fid + '&keyword=' + _this.keyword + '&articleId=' + _this.curId).then((response) => {
        if (response.data === null || response.data.length < 10) {
          _this.infiniteFinish = true
        }
        _this.articles = _this.articles.concat(response.data)
        if (_this.articles && _this.articles.length > 0) {
          _this.curId = _this.articles.slice(-1)[0].id
        }
      })
    },
    toSearchArticles () {
      this.articles = []
      this.curId = -1
      this.searchArticles()
    },

    goDetail () {
      this.$router.push({ path: '/newsEdit', query: { articleId: this.articleId, 'from': 'articles' } })
    },
    checkAll (val) {
      for (var i = 0; i < this.articles.length; i++) {
        this.checkList[i] = val
      }
      this.checkList.push(false)
    },
    changeKeyword () {
      this.curId = -1
      this.toSearchArticles()
    },
    // 批量删除进回收站
    batchRecycle () {
      let ids = ''
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i]) {
          ids = ids + this.articles[i].id
        }
        if (i < this.checkList.length - 1) {
          ids = ids + ','
        }
      }

      let _this = this
      this.axios.get('/webApi/v3/article/batchDeleteArticle?ids=' + ids).then((response) => {
        _this.$message({
          type: 'success',
          message: '文章删除成功'
        })
        _this.checkAllVal = false

        for (let i = this.checkList.length - 1; i >= 0; i--) {
          if (this.checkList[i]) {
            _this.articles.splice(i, 1)
            _this.checkList[i] = false
          }
        }

        _this.$forceUpdate()
        _this.tableIndex++
      })
    },
    // 批量导出
    batchExport () {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.checkList[i]) {
          let id = this.articles[i].id

          this.axios.get('/webApi/v3/article/exportArticle?id=' + id).then((response) => {
            let winRes = window.open(response.data, '_blank')
            if (winRes == null || typeof (winRes) === 'undefined') {
              this.$message.error('下载窗口被拦截了，请解除拦截后重新导出！');
              return
            }
            this.$message({
              message: '文章导出成功',
              type: 'success'
            })
          })
        }
      }
    },
    toRenameFolder (id, t) {
      this.curFolder = { 'id': id, 'title': t }

      this.renameFolderDialogVisible = true
    },
    renameForder () {
      let _this = this
      if (!_this.curFolder.name || _this.curFolder.name.trim() === '') {
        this.$message.error('文件夹名不能为空');
        return
      }
      this.axios.post('/webApi/v3/article/renameFolser', { 'folderId': this.curFolder.id, 'folderName': this.curFolder.name }).then((response) => {
        _this.renameFolderDialogVisible = false
        _this.toSearchArticles()
        _this.getMyFolder()
      })
    },
    toRecycleArticle (id, index) {
      this.curId = id
      this.curIndex = index
      this.deleteDialogVisible = true
    },
    // 删除文章进回收站
    recycleArticle () {
      let _this = this
      this.axios.get('/webApi/v3/article/recycleArticle?id=' + this.curId).then((response) => {
        this.$message({
          message: '文章删除成功',
          type: 'success'
        })
        _this.articles.splice(this.curIndex, 1)
        _this.deleteDialogVisible = false
      })
    },
    // 导出文章
    exportArticle (id) {
      this.axios.get('/webApi/v3/article/exportArticle?id=' + id).then((response) => {
        let winRes = window.open(response.data, '_blank')
        if (winRes == null || typeof (winRes) === 'undefined') {
          this.$message.error('下载窗口被拦截了，请解除拦截后重新导出！');
          return
        }
        this.$message({
          message: '文章导出成功',
          type: 'success'
        })
      })
    },
    handleSelectionChange (val) {
      this.checkList = []
      val.forEach(v => {
        this.articles.forEach((a, i) => {
          if (v.id === a.id) {
            this.checkList[i] = true
          }
        })
      })
    },
    // 获取文集信息
    getfolderInfo () {
      this.folderList = []
      if (!this.fid || this.fid === -1 || this.fid === '-1') {
        return
      }
      this.axios.get('/webApi/v3/article/parentList?id=' + this.fid).then((response) => {
        this.folderList = response.data
      })
    }

  },
  components: {
    xyCard,
    leftMenu
  },
  mounted () {
    this.getMyFolder();
    if (localStorage.getItem('myarticle_type_value')) {
      this.typeValue = localStorage.getItem('myarticle_type_value')
    } else {
      this.typeValue = 'card'
    }
    this.changeTypeValue()

    this.fid = this.$route.query.fid
    if (!this.fid) {
      this.fid = -1
    }

    this.keyword = ''
    this.articles = []

    this.getfolderInfo()
    this.showMenuFlag = false
    this.$nextTick(() => {
      this.showMenuFlag = true
    })
  },
  watch: {
    checkList: function () {
      this.hasAnyChoose = false
      let _this = this
      this.checkList.forEach(f => {
        if (f) {
          _this.hasAnyChoose = true
        }
      })
      this.$forceUpdate()
    },
    keyword: function (val) {
      this.changeKeyword()
    },

    '$route' (to, from) { // 监听路由是否变化
      if (to.query.fid !== this.fid) {
        this.keyword = ''
        this.fid = to.query.fid
        this.articles = []
        this.curId = -1
        this.infiniteFinish = false
        this.getfolderInfo()
        this.searchArticles()
        this.showMenuFlag = false
        this.$nextTick(() => {
          this.showMenuFlag = true
        })
        // this.$forceUpdate()
      }
    }
  }
}
</script>
<style lang="less">
.articleTypeRadio {
  display: inline-block;
  margin-left: 20px;

  .el-radio {
    margin-right: 0px;
    vertical-align: middle;
    text-align: right;

    .el-radio__input {
      display: none !important;
    }

    .el-radio__label {
      .card {
        background-image: url("../assets/imgs/menu_icon.png");
        width: 25px;
        height: 30px;
        background-position: 0px -350px;
        background-size: 400%;
      }

      .list {
        background-image: url("../assets/imgs/menu_icon.png");
        width: 25px;
        height: 30px;
        background-position: 0px -400px;
        background-size: 400%;
      }
    }
  }

  .is-checked {
    margin-right: 0px;

    .el-radio__label {
      .card {
        background-image: url("../assets/imgs/menu_icon.png");
        width: 25px;
        background-position: -50px -350px;
        background-size: 400%;
      }

      .list {
        background-image: url("../assets/imgs/menu_icon.png");
        width: 25px;
        background-position: -50px -400px;
        background-size: 400%;
      }
    }
  }

}
</style>

<style lang="less" scoped>
.work_container {
  padding: 0px;
  padding-left: 20px;
  overflow-y: auto;
}

.folderContainer {
  height: 150px;
  overflow-y: auto;
}

.noData {
  margin-top: 20px;
  padding-top: 20px;
  width: 100%;
  text-align: center;
}

.toolbar {
  .el-select {
    width: 75px;
  }

  .search_input {
    width: 225px;
  }
}

.xy_container {
  margin-top: 10px;
}

.second_article_desc {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.8em;
  color: #ccc;
  text-align: left;
}

.second_article_title {
  text-align: left;
  margin-top: 5px;
}

.xy_card {
  margin-top: 10px;
}
</style>
<style lang="less">
@import "../assets/css/index.less";

.article_checkbox {
  width: 20px !important;
  height: 20px;
  position: absolute !important;
  left: 10px !important;
  top: 30px;
  overflow: hidden;

}

.xy_home .el-radio__input {
  display: none;
}

.is-checked .el-card__body {
  background: red !important;
}

.xy_home .el-radio {
  width: 100%;
}

.f_r {
  float: right;
}

.t_l {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/app/articles.vue